import "./file-upload-counter.scss";
import m from "mithril";
import lf from "localforage";
import {triggerbackendsyncfromfrontend} from "../../../common/filesync";
import msg from "../../../common/msg";

export default () => {
	let doubletriggered = false;
	let nooffilespending = 0;
	const lf_files_data = lf.createInstance({name: "wip_localfiles_data"});
	const lf_files_filefieldsupdated = lf.createInstance({name: "wip_localfiles-filefieldsupdated"});

	const lf_data_image_files = lf.createInstance({name: "wip_image_upload_files"});

	async function CheckFileCount() {
		let filelength = await lf_files_data.length();
		let pendningloadfiles = await lf_files_filefieldsupdated.length();

		let pendingFiles = await lf_data_image_files.getItem("count");

		// console.log("new images pending", pendingFiles);

		let newnooffilespending = filelength + pendningloadfiles + (pendingFiles || 0);

		// newnooffilespending = 10;
		// console.log("checking");
		//myInterval = setInterval(CheckFileCount, 3000);
		if (newnooffilespending != nooffilespending) {
			nooffilespending = newnooffilespending;

			// console.log("about to draw");
			m.redraw();
		}
		triggerbackendsyncfromfrontend();
	}

	let myInterval = undefined;
	let touchDevice = false;
	return {
		oncreate: (u) => {
			// console.log("loaded");
			myInterval = setInterval(CheckFileCount, 3000);
			touchDevice = !!("ontouchstart" in window) || !!("onmsgesturechange" in window);
			console.log("This is a touch device: ", {touchDevice});
		},
		onbeforeunload: () => {
			clearInterval(myInterval);
		},
		view: () => {
			if (nooffilespending)
				return m(
					".file-upload-counter",
					{
						onclick: () => {
							// msg.ask("restartfileuploadprocesses", "restartfileuploadprocessesreturn", {}, "ts1");
							if (touchDevice)
								if (!doubletriggered) {
									doubletriggered = true;
									console.log({doubletriggered});
									CheckFileCount();
								} else {
									alert(
										"will try restarting file upload. It's not needed usually. If this doesn't work either, contact prasora."
									);
									triggerbackendsyncfromfrontend();
								}
						},
						onDoubleClick: () => {
							if (!touchDevice)
								if (!doubletriggered) {
									doubletriggered = true;
									console.log({doubletriggered});
									CheckFileCount();
								} else {
									alert(
										"will try restarting file upload. It's not needed usually. If this doesn't work either, contact prasora."
									);
									triggerbackendsyncfromfrontend();
								}
						},
					},
					`${nooffilespending} files pending to upload`
				);
		},
	};
};
